import request from '../../axios';
import {IPostBasketPayload} from './usePostBasket';

const postBasket = async (payload: IPostBasketPayload) => {
  await request.post(`/api/v2/order/basket`, payload);
};

export default postBasket;
